export default __webpack_public_path__ + "static/media/ic-confirmation.7f988daf.PNG";